var _rect, _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcon6(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 65,
    viewBox: "0 0 64 65",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.914062,
    width: 63.9996,
    height: 63.9992,
    rx: 31.9996,
    fill: "#EAE6FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M43 31.9141H41V29.914C41 29.3618 40.5523 28.9141 40 28.9141C39.4477 28.9141 39 29.3618 39 29.914V31.9141H37C36.4477 31.9141 36 32.3618 36 32.914C36 33.4663 36.4477 33.914 37 33.914H39V35.914C39 36.4663 39.4477 36.914 40 36.914C40.5523 36.914 41 36.4663 41 35.914V33.914H43C43.5523 33.914 44 33.4663 44 32.914C44 32.3618 43.5523 31.9141 43 31.9141Z",
    fill: "#6F4EF6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M29 32.9141C32.3137 32.9141 35 30.2278 35 26.9141C35 23.6004 32.3137 20.9141 29 20.9141C25.6863 20.9141 23 23.6004 23 26.9141C23 30.2278 25.6863 32.9141 29 32.9141Z",
    fill: "#6F4EF6"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M29 34.9141C24.0317 34.9196 20.0055 38.9458 20 43.9141C20 44.4663 20.4477 44.914 21 44.914H37C37.5522 44.914 38 44.4663 38 43.9141C37.9945 38.9458 33.9683 34.9195 29 34.9141Z",
    fill: "#6F4EF6"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon6);
export default __webpack_public_path__ + "static/media/icon (6).78f49f5a0c16d3615534b208a4b84a66.svg";
export { ForwardRef as ReactComponent };